import * as Styles from './styles';
import SummaryCard, { SummaryCardConfig } from './SummaryCard';

type MobileSummaryCardProps = {
    summaryCardConfig: SummaryCardConfig[];
    startDate: Date;
    endDate: Date;
};

function MobileSummaryCard({
    summaryCardConfig,
    startDate,
    endDate,
}: MobileSummaryCardProps) {
    return (
        <Styles.MobileSummaryCard>
            <Styles.SummaryLabel>
                {summaryCardConfig[0].label}
            </Styles.SummaryLabel>
            {summaryCardConfig[0].isLoading ? (
                <Styles.ValueSkeleton />
            ) : (
                <Styles.SummaryValue>
                    {summaryCardConfig[0].value}
                </Styles.SummaryValue>
            )}
            <Styles.MobileMiniSummaryRow>
                {summaryCardConfig.slice(1).map((config) => (
                    <SummaryCard
                        key={config.label}
                        config={config}
                        startDate={startDate}
                        endDate={endDate}
                        isMobile
                    />
                ))}
            </Styles.MobileMiniSummaryRow>
        </Styles.MobileSummaryCard>
    );
}

export default MobileSummaryCard;
